import { render, staticRenderFns } from "./CiudadIndex.vue?vue&type=template&id=32d40f4f"
import script from "./CiudadIndex.vue?vue&type=script&lang=js"
export * from "./CiudadIndex.vue?vue&type=script&lang=js"
import style0 from "./CiudadIndex.vue?vue&type=style&index=0&id=32d40f4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports